module.exports = __webpack_public_path__ + "img/blog1.bf848563.jpg";